import { t } from "@travily/i18n";
import { ButtonDock } from "@ui/components/ButtonDock";
import { Dialog } from "@ui/components/Dialog";
import { Icon } from "@ui/components/Icon";
import { StandardButton } from "@ui/components/StandardButton";
import { StandardTextField } from "@ui/components/StandardTextField";
import type { FormEvent } from "react";

export interface FormStepProps {
  email: string;
  emailError?: string;
  onEmailChange: (value: string) => void;
  onEmailBlur?: () => void;
  onSubmit: () => void;
  onClose: () => void;
  isPending: boolean;
}

export function FormStep({
  email,
  emailError,
  onEmailChange,
  onEmailBlur,
  onSubmit,
  onClose,
  isPending,
}: FormStepProps) {
  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onSubmit();
  };

  return (
    <form onSubmit={handleSubmit} noValidate className="flex h-full flex-col">
      <Dialog.Header onClose={onClose} title={t("components.views.magic_links.email_modal.form.title")} />
      <Dialog.Body>
        <div className="px-1">
          <StandardTextField
            autoFocus
            autoComplete="email"
            description={t("components.views.magic_links.email_modal.form.description")}
            errorMessage={emailError}
            isInvalid={Boolean(emailError)}
            label={t("components.views.magic_links.email_modal.form.email_label")}
            leadIcon={<Icon name="mail" type="sticker" />}
            name="email"
            onBlur={onEmailBlur}
            onChange={onEmailChange}
            placeholder={t("components.views.magic_links.email_modal.form.email_placeholder")}
            type="email"
            value={email}
          />
        </div>
      </Dialog.Body>
      <Dialog.Footer>
        <ButtonDock
          primaryAction={
            <StandardButton color="pink" isPending={isPending} size="44" type="submit">
              {t("components.views.magic_links.email_modal.form.submit")}
            </StandardButton>
          }
        />
      </Dialog.Footer>
    </form>
  );
}
